import fetchJson from './fetchJson';
import {Theme} from "../model/Theme";
import {organizationalUrl} from "../services/urlProvider";

export const fetchTheme = () : Promise<Theme>=>{
  const url = organizationalUrl();
  return fetchJson(`${url}/theme.json`);
};
